import React, { useState, useEffect } from "react";
import "./css/Alerts.css";
import headerBg from "./assets/picOne.png";
import { Megaphone } from "lucide-react";

const alertsData = [
  // {
  //   id: 1,
  //   title:
  //     "CONSUMER ALERT: CONTAMINATED BOTTLED WATER DETECTED – MBS/ALERT/2025/01",
  //   date: "2025-10-20",
  //   type: "Consumer",
  //   content:
  //     "Laboratory testing by MBS has detected microbiological contamination in some bottled water. Consumers should avoid consuming these batches.",
  // },
  // {
  //   id: 2,
  //   title: "SAFETY ALERT: FAKE ELECTRICAL CABLES ON MARKET – MBS/ALERT/2025/02",
  //   date: "2025-10-18",
  //   type: "Safety",
  //   content:
  //     "Counterfeit electrical cables pose fire and electrocution risks. Consumers should verify supplier certification.",
  // },
  // {
  //   id: 3,
  //   title: "RECALL ALERT: DEFECTIVE TOASTER MODELS – MBS/ALERT/2025/03",
  //   date: "2025-10-15",
  //   type: "Recall",
  //   content:
  //     "Certain toaster models have been recalled due to overheating issues that may cause fire hazards.",
  // },
  // {
  //   id: 4,
  //   title:
  //     "REGULATORY ALERT: NEW SAFETY STANDARDS FOR CHILD TOYS – MBS/ALERT/2025/04",
  //   date: "2025-10-12",
  //   type: "Regulatory",
  //   content:
  //     "Updated safety regulations require all toy manufacturers to comply immediately with MBS standards.",
  // },
  // {
  //   id: 5,
  //   title:
  //     "CONSUMER ALERT: EXPIRED MEDICINE FOUND IN MARKET – MBS/ALERT/2025/05",
  //   date: "2025-10-10",
  //   type: "Consumer",
  //   content:
  //     "Expired medication has been detected in pharmacies. Consumers should check expiration dates before purchase.",
  // },
  // {
  //   id: 6,
  //   title: "SAFETY ALERT: ELECTRICAL OUTLETS RISKING FIRE – MBS/ALERT/2025/06",
  //   date: "2025-10-08",
  //   type: "Safety",
  //   content:
  //     "Certain electrical outlets may short-circuit and cause fire hazards. Users should avoid using these models.",
  // },
  // {
  //   id: 7,
  //   title: "RECALL ALERT: DEFECTIVE KITCHEN KNIVES – MBS/ALERT/2025/07",
  //   date: "2025-10-05",
  //   type: "Recall",
  //   content:
  //     "Sharp kitchen knives sold in some stores have defective handles. Consumers should return affected products.",
  // },
  // {
  //   id: 8,
  //   title:
  //     "REGULATORY ALERT: NEW LABELING REQUIREMENTS FOR FOOD PRODUCTS – MBS/ALERT/2025/08",
  //   date: "2025-10-02",
  //   type: "Regulatory",
  //   content:
  //     "All packaged food products must comply with updated labeling rules indicating ingredients and allergens.",
  // },
  // {
  //   id: 9,
  //   title: "CONSUMER ALERT: UNSAFE CHILD CAR SEATS – MBS/ALERT/2025/09",
  //   date: "2025-09-28",
  //   type: "Consumer",
  //   content:
  //     "Some imported child car seats fail safety tests. Parents should check MBS certification before use.",
  // },
  // {
  //   id: 10,
  //   title:
  //     "SAFETY ALERT: FAKE FIRE EXTINGUISHERS IN MARKET – MBS/ALERT/2025/10",
  //   date: "2025-09-25",
  //   type: "Safety",
  //   content:
  //     "Counterfeit fire extinguishers are circulating locally. Users should verify authenticity to ensure fire safety.",
  // },
  // {
  //   id: 11,
  //   title: "RECALL ALERT: DEFECTIVE MOBILE CHARGERS – MBS/ALERT/2025/11",
  //   date: "2025-09-22",
  //   type: "Recall",
  //   content:
  //     "Certain mobile chargers overheat and risk fire. Consumers should return affected models immediately.",
  // },
  // {
  //   id: 12,
  //   title:
  //     "REGULATORY ALERT: UPDATED ELECTRICAL INSTALLATION CODES – MBS/ALERT/2025/12",
  //   date: "2025-09-20",
  //   type: "Regulatory",
  //   content:
  //     "New electrical installation codes have been issued. All electricians and contractors must comply.",
  // },
  // {
  //   id: 13,
  //   title: "CONSUMER ALERT: POOR QUALITY SANITARY PRODUCTS – MBS/ALERT/2025/13",
  //   date: "2025-09-18",
  //   type: "Consumer",
  //   content:
  //     "Some imported sanitary products fail absorbency and hygiene tests. Consumers should verify certification.",
  // },
  // {
  //   id: 14,
  //   title: "SAFETY ALERT: DEFECTIVE GAS COOKERS – MBS/ALERT/2025/14",
  //   date: "2025-09-15",
  //   type: "Safety",
  //   content:
  //     "Certain gas cookers are prone to gas leaks and fire. Consumers should stop using affected units.",
  // },
  // {
  //   id: 15,
  //   title: "RECALL ALERT: FAULTY BATTERIES IN ELECTRONICS – MBS/ALERT/2025/15",
  //   date: "2025-09-12",
  //   type: "Recall",
  //   content:
  //     "Batteries sold in certain electronics devices are defective and may overheat. Users should replace them immediately.",
  // },
];

const themeColor = "#FF5400";
const getIcon = (type) => <Megaphone color={themeColor} size={20} />;

const AlertsPage = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [filterDate, setFilterDate] = useState("");
  const [selectedAlert, setSelectedAlert] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [alertsPerPage, setAlertsPerPage] = useState(5);

  const filteredAlerts = alertsData
    .filter(
      (alert) =>
        searchTerm === "" ||
        alert.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
        alert.content.toLowerCase().includes(searchTerm.toLowerCase())
    )
    .filter((alert) => (filterDate === "" ? true : alert.date === filterDate))
    .sort((a, b) => new Date(b.date) - new Date(a.date));

  const indexOfLastAlert = currentPage * alertsPerPage;
  const indexOfFirstAlert = indexOfLastAlert - alertsPerPage;
  const currentAlerts = filteredAlerts.slice(
    indexOfFirstAlert,
    indexOfLastAlert
  );
  const totalPages = Math.ceil(filteredAlerts.length / alertsPerPage);

  const handlePrevPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  const handlePerPageChange = (e) => {
    setAlertsPerPage(Number(e.target.value));
    setCurrentPage(1);
  };

  // Set default selected alert only on page load / alerts change
  //useEffect(() => {
  //if (!selectedAlert && currentAlerts.length > 0) {
  //setSelectedAlert(currentAlerts[0]);
  //}
  //}, [currentAlerts]); // removed selectedAlert from dependencies

  return (
    <div className="alerts-page">
      <section
        className="alerts-hero"
        style={{ backgroundImage: `url(${headerBg})` }}
      >
        <div className="alerts-hero-content">
          <h1>Public Alerts</h1>
          <p>
            Stay up to date with the latest consumer, safety, and regulatory alerts
            issued by the Malawi Bureau of Standards.
          </p>
        </div>
      </section>

      {/* Main Section */}
      <section className="alerts-main">
        {/* Left column */}
        <div className="alerts-left-column">
          <h2>Stay Informed with MBS Alerts</h2>
          <p>
            At the Malawi Bureau of Standards (MBS), we safeguard public health
            and safety. Our alerts provide timely information about product
            recalls, safety hazards, regulatory updates, and consumer
            advisories.
          </p>

          <p className="left-column-footer">
            MBS ensures transparency, quality, and trust in every alert we
            issue.
          </p>
        </div>

        {/* Right column */}
        <div className="alerts-right-column">
          {/* Filters */}
          <div className="alerts-filter-row">
            <input
              type="text"
              placeholder="Search alerts..."
              className="alerts-search"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <input
              type="date"
              className="alerts-date"
              value={filterDate}
              onChange={(e) => setFilterDate(e.target.value)}
            />
          </div>

          {/* Table */}
          <div className="alerts-table-container">
            <table className="alerts-table">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Title</th>
                  <th>Date</th>
                  <th>Type</th>
                  <th>View</th>
                </tr>
              </thead>
              <tbody>
                {currentAlerts.map((alert) => (
                  <tr key={alert.id}>
                    <td>{alert.id}</td>
                    <td>{alert.title}</td>
                    <td>{new Date(alert.date).toLocaleDateString()}</td>
                    <td>{alert.type}</td>
                    <td>
                      <button
                        className="view-btn"
                        onClick={() => setSelectedAlert(alert)}
                      >
                        View
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Pagination */}
          <div className="pagination-controls">
            <div className="page-size-selector">
              Show{" "}
              <select value={alertsPerPage} onChange={handlePerPageChange}>
                {[5, 10, 20].map((num) => (
                  <option key={num} value={num}>
                    {num}
                  </option>
                ))}
              </select>{" "}
              per page
            </div>
            <div className="pagination-info">
              Showing {indexOfFirstAlert + 0}–
              {Math.min(indexOfLastAlert, filteredAlerts.length)} of{" "}
              {filteredAlerts.length} alerts
            </div>
            <div className="pagination-buttons">
              <button
                className="pagination-btn"
                onClick={handlePrevPage}
                disabled={currentPage === 1}
              >
                Previous
              </button>
              <button
                className="pagination-btn"
                onClick={handleNextPage}
                disabled={indexOfLastAlert >= filteredAlerts.length}
              >
                Next
              </button>
            </div>
          </div>

          {/* Modal */}
          {selectedAlert && (
            <div className="alert-modal" onClick={() => setSelectedAlert(null)}>
              <div
                className="alert-modal-content"
                onClick={(e) => e.stopPropagation()}
              >
                <span
                  className="close-modal"
                  onClick={() => setSelectedAlert(null)}
                >
                  &times;
                </span>
                <h2>{selectedAlert.title}</h2>
                <p className="alerts-detail-date">
                  {new Date(selectedAlert.date).toLocaleDateString()} -{" "}
                  {selectedAlert.type} Alert
                </p>
                <p className="alerts-detail-content">{selectedAlert.content}</p>
              </div>
            </div>
          )}
        </div>
      </section>
    </div>
  );
};

export default AlertsPage;
